import React, { Component } from 'react';

// This component is a wrapper of Wavesurfer that makes sure Wavesurfer is only
// rendered on the client, not the server.
class Waveform extends Component {

    constructor(props) {
        super(props);

        this.state = {
            Wavesurfer: null
        };

        this.loadWaveSurferInBrowser = this.loadWaveSurferInBrowser.bind(this);
    }

    componentDidMount() {
        this.loadWaveSurferInBrowser();
    }

    loadWaveSurferInBrowser() {
        if (!this.state.Wavesurfer && typeof window !== 'undefined') {
            // Dynamic imports and require.ensure break Medusa, so a regular
            // require is needed here...
            require('wavesurfer.js');
            const component = require('react-wavesurfer').default;
            this.setState(() => ({Wavesurfer: component}));
        }
    }

    render() {
        const { Wavesurfer } = this.state;
        return Wavesurfer
            ? <Wavesurfer {...this.props}/>
            : <div>...</div>;
    }
}

export default Waveform;
